<template>
  <div class="head-page">
    <Header :title="title" />
    <van-tabs v-model="active">
      <van-tab :title="item.value" v-for="item in recordtype" :key="item.key" :name="item.key" />
    </van-tabs>
    <div style="padding-bottom: 20px">
      <FinanceTable v-if="active == 1" :cid="id" :type="type" />
      <WithdrawalTable v-if="active == 2" :cid="id" :type="type" />
      <RechargeTable v-if="active == 3" :cid="id" :type="type" />
      <ChangeTable v-if="active == 4" :cid="id" :type="type" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {
  FinanceTable,
  WithdrawalTable,
  RechargeTable,
  ChangeTable,
} from "./components/index";
export default {
  name: "TradeAccount",
  components: {
    Header,
    FinanceTable,
    WithdrawalTable,
    RechargeTable,
    ChangeTable,
  },
  data() {
    return {
      title: this.$t("assets.tab21"),
      active: null,
      recordtype: [
        
      ],
      id: null,
      type: null,
      usd: null,
      conversion: null,
      name: null,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.name = this.$route.query.name;
    this.usd = this.$route.query.usd;
    this.conversion = this.$route.query.conversion;

    this.initPage()
  },
  methods: {
    initPage() {

        this.title = '';
        this.recordtype = [
          { key: 1, value: this.$t("assets.tbhead1") },
          { key: 2, value: this.$t("assets.tbhead2") },
          { key: 3, value: this.$t("assets.tbhead3") },
        ];
      
    },
  },
};
</script>

<style>
</style>
